import { errorMessage } from "../../utils/helpers";

export const extractTemplateDeleteErrorMessage = (error: any, templateName: string) => {
  const backendMessage = typeof error?.data?.message === "string" ? error.data.message.trim() : "";
  if (backendMessage.length > 0) {
    if (backendMessage.startsWith("Template cannot be deleted.")) {
      const taskSummary = backendMessage.replace("Template cannot be deleted. Template associated with task(s):", "").trim();
      return `Template "${templateName}" cannot be deleted. Used in task(s): ${taskSummary}`;
    }
    return backendMessage;
  }

  if (typeof error?.data === "string" && error.data.trim().length > 0) {
    return error.data.trim();
  }

  return `Failed to delete template "${templateName}": ${errorMessage(error)}`;
};